import request from '@/shared/api/request';

export const deleteKubernetes = (uuid: string): Promise<void> =>
  request({
    url: `/kubernetes/${uuid}/`,
    method: 'DELETE',
  });
